import { useMemo } from "react";
import { Button } from "ui/components/Button/Button";
import FileUploadList from "ui/components/FileUpload/FileUploadList/FileUploadList";
import { FleetDocumentUpload } from "services/api/fleet/vehicles/documents/types";
import { ImportFileStepProps } from "./types";

/** Korak 2 — odabir ispunjene XLSX datoteke (dizajn kao upload slika na kontaktu). */
const ImportFileStep: React.FC<ImportFileStepProps> = (props) => {
  const { selectedFile, error, onOpenFileModal, onRemoveFile } = props;

  const uploadFiles: FleetDocumentUpload[] = useMemo(
    () =>
      selectedFile
        ? [
            {
              id: selectedFile.id,
              originalFileName: selectedFile.name,
              fileExtension: selectedFile.name.split(".").pop() ?? "",
              fileSizeKb: Math.round((selectedFile.size || 0) / 1024),
              contentType: selectedFile.type || "",
              created: new Date(),
              url: selectedFile.url ?? "",
              name: selectedFile.name,
            },
          ]
        : [],
    [selectedFile]
  );

  return (
    <div className="flex items-center justify-center px-4 mt-8 xl:mt-16 min-h-[60vh] xl:min-h-[600px]">
      <div className="w-full max-w-4xl">
        <h1 className="text-2xl font-bold text-slate-900 text-center mb-1">
          Učitajte datoteku
        </h1>
        <p className="text-center text-sm text-slate-600 mb-6 max-w-2xl mx-auto ">
          Odaberite ispunjenu XLSX datoteku za skupni uvoz vozila.
        </p>

        <div className="px-3">
          <Button
            variant="outlined"
            size="small"
            startIcon="/media/icons/plus.svg"
            onClick={onOpenFileModal}
          >
            Dodaj datoteku
          </Button>

          {selectedFile ? (
            <div className="mt-3">
              <FileUploadList
                files={uploadFiles}
                onDelete={onRemoveFile}
                deleteTitle="Brisanje datoteke?"
                deleteMessage="Jeste li sigurni da želite obrisati datoteku?"
              />
            </div>
          ) : (
            <div
              className="mt-3 border-2 border-dashed border-slate-300 rounded-sm p-6 text-center text-sm text-slate-400 cursor-pointer hover:border-blue-400 hover:text-blue-500 transition-colors"
              onClick={onOpenFileModal}
            >
              Dodajte datoteku
            </div>
          )}

          {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default ImportFileStep;
